import React, { useState } from "react";

import { ArrowDownIcon } from "@/assets/icons";

import { Button } from "equator-design-system";
import { twMerge } from "tailwind-merge";

interface CollapsibleProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  titleClassName?: string;
  expanded?: boolean;
  /** Keeps the section open while its content contains a required action. */
  forceExpanded?: boolean;
}

const CollapseView = ({
  title,
  children,
  className,
  titleClassName,
  expanded = false,
  forceExpanded = false
}: Readonly<CollapsibleProps>) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const isContentExpanded = forceExpanded || isExpanded;

  const toggleExpand = () => {
    setIsExpanded((previous) => !previous);
  };

  return (
    <div className="flex flex-col">
      <div
        className={twMerge(
          "flex justify-between items-center cursor-pointer px-4 h-[40px]",
          className
        )}
      >
        <span
          className={twMerge(
            "text-base text-txtHeading font-semibold",
            titleClassName
          )}
        >
          {title}
        </span>
        <Button
          variant="ghost"
          className={twMerge(isContentExpanded ? "rotate-180" : "")}
          onClick={toggleExpand}
          type="button"
          aria-label={`Toggle ${title} section`}
          aria-expanded={isContentExpanded}
          disabled={forceExpanded}
        >
          <ArrowDownIcon className="w-[24px] h-[24px] fill-txtBody" />
        </Button>
      </div>
      {isContentExpanded && <div className="mt-2">{children}</div>}
    </div>
  );
};

export default CollapseView;
